export const GRAPH_NAMES_TREND = {
    DEMOGRAPHICS_TOPICS: "Demographics-Topics",
    DEMOGRAPHICS_QUESTIONS: "Demographics-Questions"
}

export const TOAST_ERROR = "Atleast 1 selection needed"